import { customerService, washService } from '@/services/firebase'
import { normalizeLicensePlate } from '@/utils/licensePlate'

function vehicleLabel(vehicle = {}) {
  const make = String(vehicle.make || '').trim()
  const model = String(vehicle.model || '').trim()
  if (make && model) return `${make} ${model}`
  return make || model || 'Vehicle'
}

export const vehicleLookupService = {
  async lookupByPlate(plate, branchId = null) {
    const norm = normalizeLicensePlate(plate)
    if (!norm || norm.length < 4) {
      return { found: false, plate: norm, error: 'invalid_plate' }
    }

    const customer = await customerService.getCustomerByLicensePlate(norm)
    if (customer) {
      const vehicle = customerService.vehicleFromProfile(customer)
      return {
        found: true,
        plate: norm,
        customer,
        vehicle,
        vehicleLabel: vehicleLabel(vehicle),
        source: 'customer',
      }
    }

    const wash = await washService.findRecentWashByPlate(norm, branchId)
    if (wash?.customerId) {
      const washCustomer = await customerService.getCustomerById(wash.customerId)
      if (washCustomer) {
        const vehicle = wash.carDetails || {}
        return {
          found: true,
          plate: norm,
          customer: washCustomer,
          vehicle,
          vehicleLabel: vehicleLabel(vehicle),
          source: 'wash_history',
        }
      }
    }

    return { found: false, plate: norm }
  },
}
